<div class="flex flex-col items-start gap-4">
  @for (req of requirements(); track req) {
    <div
      class="flex items-center gap-2 text-secondary-text"
      aria-live="polite"
      aria-atomic="true"
    >
      <div
        class="flex size-5 shrink-0 grow-0 items-center justify-center rounded-full border border-black"
        [ngClass]="{ 'border-border-success bg-border-success': req.isValid() }"
      >
        <div class="size-2 rounded-full bg-white"></div>
      </div>
      <div>
        <span class="sr-only">
          {{
            (req.isValid()
              ? 'pages.auth.passwordRequirements.passing'
              : 'pages.auth.passwordRequirements.notPassing'
            ) | translate
          }}
        </span>
        <span>{{
          ['pages.auth.passwordRequirements', req.label]
            | join: undefined : '.'
            | translate
        }}</span>
      </div>
    </div>
  }
</div>
